/*
 * Jira Ticket:
 * Created Date: Wed, 1st Apr 2020, 15:02:53 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneTowerInspectionQuery = gql`
  query TowerInspection($id: ID!) {
    data: TowerInspection(id: $id) {
      id
      cmsStatus
      tower {
        cmsStatus
        id
        type {
          id
          name
        }
        builderQualified
        builder {
          name
          certificateNumber
        }
        site {
          id
          name
          location {
            lat
            lng
          }
          project {
            id
            name
            checklistType
            organisation {
              id
              name
            }
          }
        }
        environment
        platformHeight
        tag
        status
        notes
      }
      permissions {
        allowPDFExport
      }
      inspectionNumber
      status
      inspectedAt
      inspectedBy {
        name
      }
      reviewedBy {
        name
      }
      inspectorComments
      isExpired
      reviewerComments
      images {
        id
        url
      }
    }
  }
`;
